<template>
    <div
            class="input-error"
            v-if="fieldErrors.length"
    >
        <transition-group
                name="fade"
                tag="div"
        >
            <b-form-invalid-feedback
                    class="mt-1"
                    v-for="(message,i) in fieldErrors"
                    :key="i+1"

                    :state="true"
                    :force-show="true"
            >
                <div v-html="`${message.ucFirst()}`" />
            </b-form-invalid-feedback>
        </transition-group>
        <br>
    </div>
</template>

<script>
    import get from 'lodash/get';

    export default {
        name: 'InputError',
        props: {
            errors: {
                type: [Object, Array],
            },
            field: {
                type: [String],
            },
        },
        data() {
            return {};
        },
        watch: {
            errors() {
            },
        },
        computed: {
            fieldErrors() {
                const errors = get(this.errors, this.field);
                if (typeof errors === 'string') {
                    return [
                        errors,
                    ];
                }
                return errors || [];
            },
        },
    };
</script>
